// @flow
import { ACTIONS } from '../constants';
import getNotificationSettings from '../api/getNotificationSettings';

const loadNotificationSettings = () => async (dispatch: Function) => {
    const settings = await getNotificationSettings();

    dispatch({
        type: ACTIONS.NOTIFICATION_SETTINGS_LOADED,
        settings
    });
};

export default loadNotificationSettings;
